function asm_pass_data () {
	var tmp_server_str = '';

    if (document.getElementById('checkout_shipping_address_first_name'))
        var first_name = document.getElementById('checkout_shipping_address_first_name').value;

    if (document.getElementById('checkout_shipping_address_last_name'))
        var last_name = document.getElementById('checkout_shipping_address_last_name').value;

      if (document.getElementById('checkout_shipping_address_zip'))
        var zip_code = document.getElementById('checkout_shipping_address_zip').value;

	if ((asm_discount_value > 0) && (asm_discount_code == ''))
		asm_discount_code = 'DUMMYCODE';

    var cur_page = 'checkout';
    if (document.getElementById('your-shopping-cart'))
       cur_page = 'cart';
        
	tmp_server_str = first_name +' '+ last_name +'|'+ zip_code +'|'+ asm_subtotal +'|'+ asm_discount_code +'|'+ asm_discount_value +'|'+ asm_checkout_token;
	if (tmp_server_str != asm_server_str) {
		asm_server_str = tmp_server_str;

      	document.getElementById('asm-ajax').src = 'https://www.advancedshippingmanager.com/clients/shopify_plus_discount_logging.php?si=' + asm_store_id +'&val='+ asm_server_str +'&cp='+ cur_page;
      
//		console.log (asm_server_str);
	}
}

function asm_read_cart_data () {
	var xhr = new XMLHttpRequest();
	xhr.withCredentials = true;
        
	xhr.addEventListener('readystatechange', function () {
		if (this.readyState === this.DONE) {
			var asm_cart_obj = JSON.parse(xhr.response);

            var excluded_value = 0;
            for (i = 0; i < asm_cart_obj['items'].length; i++) {
                if (asm_cart_obj['items'][i]['requires_shipping'] == false)
                    excluded_value = excluded_value + parseFloat(asm_cart_obj['items'][i]['price']);
            }
          
            asm_subtotal = ((asm_cart_obj['items_subtotal_price'] - excluded_value) / 100);

            if (document.querySelector('.total.discounted span.price')) {
                asm_discount_value = document.querySelector('.total.discounted span.price').innerHTML.replace('-$','');
            }
          
            asm_pass_data();
		}
	});
        
	xhr.open('GET', '/cart.js');
	xhr.send();
}  

function asm_read_discount_code_value () {
	asm_discount_value = 0;
  	var discount_code_value = '';
  	var tmp_asm_discount_value = '';
	var order_summary = document.getElementById('order-summary');
    var span_tags = document.querySelector('.order-summary__section.order-summary__section--product-list').getElementsByTagName('span');
    for (x = 0; x < span_tags.length; x++) {
        if (span_tags[x].className.indexOf('reduction-code__text') != -1) {
            discount_code_value = span_tags[x].innerHTML.trim();

            var parenthesis_start = discount_code_value.indexOf ('(');
            if (parenthesis_start != -1) {
                asm_discount_code = discount_code_value.substring (0, parenthesis_start - 1);
                tmp_asm_discount_value = discount_code_value.substring (parenthesis_start + 1, discount_code_value.length - 1);
                tmp_asm_discount_value = tmp_asm_discount_value.replace ('-$', '');
                asm_discount_value = asm_discount_value + parseFloat (tmp_asm_discount_value);
            } else {
                asm_discount_code = discount_code_value;
            }
          
            if ((asm_discount_code != '') && (asm_discount_value == 0)) {
                var tr_tags = order_summary.getElementsByTagName('tr');
                for (i = 0; i < tr_tags.length; i++) {
                    if (tr_tags[i].className.indexOf ('total-line--reduction') != -1) {
                        var span_tags = tr_tags[i].getElementsByTagName('span');
                        for (x = 0; x < span_tags.length; x++) {
                            if (span_tags[x].innerHTML.indexOf ('$') != -1) {
                                tmp_asm_discount_value = span_tags[x].innerHTML.trim();
                                asm_discount_value = asm_discount_value + parseFloat (tmp_asm_discount_value.replace ('- $', ''));
                                break;
                            }
                        }
                    }
                }                  
            } else {
                asm_discount_value = asm_discount_value + 0;
            }
        }
	}
  
  	asm_pass_data();

  	asmDiscountCode = setTimeout(function(){ asm_read_discount_code_value(); }, 100);
}

function asm_click_info_link () {
	var nav_tag = document.getElementsByTagName('nav');
	var a_tags = nav_tag[0].getElementsByTagName('a');
	for (i = 0; i < a_tags.length; i++) {
		if (a_tags[i].innerHTML == 'Information') {
			a_tags[i].click();
		}
	}	
}

function asm_hide_discount () {
	var order_summary = document.getElementById('order-summary');
	var div_tags = order_summary.getElementsByTagName('div');
	for (i = 0; i < div_tags.length; i++) {
		if (div_tags[i].className == 'order-summary__section order-summary__section--discount') {
			div_tags[i].style.display = 'none';

			var discount_div = document.createElement('div');
			discount_div.setAttribute('id', 'asm-pseudo-discount-code-text');
			discount_div.setAttribute('style', 'margin: 10px; font-weight: bold;');
         	div_tags[i].parentNode.insertBefore(discount_div, div_tags[i].nextSibling);

			document.getElementById('asm-pseudo-discount-code-text').innerHTML = 'To apply a discount code, please <span style="color: blue; cursor: pointer;" onclick="asm_click_info_link();">click here</span> to return to Information page.';
		}
	}
}

function asm_set_window (data) {
	if (window.name.indexOf('|asm:') != -1) {
		var pm_data_begin = window.name.indexOf('|asm:');
		var pm_data_end = window.name.indexOf('|', pm_data_begin + 1);

		var new_window_name = '';
		if (pm_data_end != -1) {
			new_window_name = window.name.substring(0, pm_data_begin);
			new_window_name = new_window_name + window.name.substring(pm_data_end, window.name.length);
		} else if (pm_data_end == -1)
			new_window_name = window.name.substring(0, pm_data_begin);

		window.name = new_window_name + '|asm:' + data; 
	} else
		window.name = window.name + '|asm:' + data; 
}

function asm_read_window () {
	var data_pieces = window.name.split('|');
	for (i = 0; i < data_pieces.length; i++) {
		if (data_pieces[i].indexOf('asm:') != -1) {
			return data_pieces[i].replace('asm:', '');
		}
	}

	return '';
}

function asm_add_event (obj, evType, fn) {
	if (obj.addEventListener) {
		obj.addEventListener(evType, fn, false);
		return true;
	} else if (obj.attachEvent) {
		var r = obj.attachEvent('on'+evType, fn);
		return r;
	} else {
		return false;
	}
}

function asm_form_init () {
  	asmDiscountCode = setTimeout(function(){ asm_read_discount_code_value(); }, 100);
   
	if (document.getElementById('checkout_shipping_address_first_name'))
		asm_add_event (document.getElementById('checkout_shipping_address_first_name'), 'blur', asm_pass_data);

	if (document.getElementById('checkout_shipping_address_last_name'))
		asm_add_event (document.getElementById('checkout_shipping_address_last_name'), 'blur', asm_pass_data);

	if (document.getElementById('checkout_shipping_address_zip'))
		asm_add_event (document.getElementById('checkout_shipping_address_zip'), 'blur', asm_pass_data);
 
   	asm_read_cart_data();
}

function asm_cart_init () {
    if (document.querySelector('.total.discounted span.price').innerHTML != '')
        var tmp_discount = document.querySelector('.total.discounted span.price').innerHTML.replace('-$','');

    if (tmp_discount > 0)
        asm_read_cart_data();
    else
        setTimeout(function(){ asm_cart_init(); }, 100);
}

var asm_store_data = '';
if (document.getElementById('shopify-features'))
    asm_store_data = JSON.parse(document.getElementById('shopify-features').innerHTML);
else if (Shopify.Checkout.dynamicCheckoutPaymentInstrumentsConfig.paymentInstruments.checkoutConfig.domain)
	asm_store_data = Shopify.Checkout.dynamicCheckoutPaymentInstrumentsConfig.paymentInstruments.checkoutConfig;
else
    asm_store_data.domain = 'myshopify.com';

var asm_cookie_domain = asm_store_data.domain;
var asm_cookie_domain = asm_cookie_domain.replace(/^[^.]+\./g, "");

var asm_checkout_token = '';

var asmDiscountCode;

var asm_subtotal = '';
var asm_discount_code = '';
var asm_discount_value = 0;
var asm_server_str = '';

var asm_store_id = '';

if (typeof Shopify.Checkout != 'undefined') {
    asm_store_id = Shopify.Checkout.apiHost.replace ('.myshopify.com', '');
    asm_checkout_token = Shopify.Checkout.token;

    asm_set_window (asm_store_id +'~'+ asm_checkout_token)
  
    if (Shopify.Checkout.step == 'contact_information') {
		asm_form_init();
    } else if ((Shopify.Checkout.step == 'shipping_method') || (Shopify.Checkout.step == 'payment_method') || (Shopify.Checkout.step == 'processing') || (Shopify.Checkout.step == 'review')) {
		asm_hide_discount();
    }
} else if (document.getElementById('your-shopping-cart')) {
    var tmp_asm_data = asm_read_window().split('~');
    asm_store_id = tmp_asm_data[0];
    asm_checkout_token = tmp_asm_data[1];
  
    if ((asm_store_id != '') && (asm_checkout_token != '')) {
        asm_cart_init();
    }
}